<div class="highlighted-container container">
    <div class="row">
        <div class="highlighted">  
            <div class="region region-highlighted">
                <h1 class="page-header">
                    <span>{{ 'REQUEST_ADDRESS_CHANGE_HEADING' | translate }}</span>
                </h1>
            </div>
        </div>
    </div>
</div>

<div class="main-container container">
    <div class="row" *ngIf="!isActiveLease">
        <section class="col-sm-2"></section>
        <section class="col-sm-8">
            <p class="page-subtitle">{{ 'COMMON_LBL_ERROR_MSG_NO_ACTIVE_LEASE' | translate }}</p>
            <p></p>
        </section>
        <section class="col-sm-2"></section>
    </div>
    <div class="row" *ngIf="isActiveLease">
        <section class="col-sm-2"></section>
        <section class="col-sm-8">
            <div class="region region-content">
                <form class="custom-from" #customForm="ngForm" (ngSubmit)="submitForm(customForm)" novalidate>
                    <div class="row">
                        <section class="col-sm-6 lb"><label class="star">*</label>{{ 'REQUEST_ADDRESS_CHANGE_INPUT_ADDRESS1' | translate }}</section>
                        <section class="col-sm-6">
                            <input type="text" 
                                class="form-control" 
                                id="address1" name="address1" 
                                [(ngModel)]="request.address1"   
                                [ngClass]="{ 'is-invalid': formSubmitted && customForm.controls.address1.errors }"
                                placeholder="{{ 'COMMON_LBL_REQUIRED' | translate }}"                                              
                                required maxlength="255"/>
                        </section>
                        <section class="col-sm-6 lb">{{ 'REQUEST_ADDRESS_CHANGE_INPUT_ADDRESS2' | translate }}</section>
                        <section class="col-sm-6">
                            <input type="text" 
                                class="form-control" 
                                id="address2" name="address2" 
                                [(ngModel)]="request.address2"                   
                                maxlength="255"/>
                        </section>
                        <section class="col-sm-6 lb"><label class="star">*</label>{{ 'REQUEST_ADDRESS_CHANGE_INPUT_CITY' | translate }}</section>
                        <section class="col-sm-6">
                            <input type="text" 
                                class="form-control" 
                                id="city" name="city" 
                                [(ngModel)]="request.city"   
                                [ngClass]="{ 'is-invalid': formSubmitted && customForm.controls.city.errors }"
                                placeholder="{{ 'COMMON_LBL_REQUIRED' | translate }}"                                              
                                required maxlength="50"/>
                        </section>
                        <section class="col-sm-6 lb"><label class="star">*</label>{{ 'REQUEST_ADDRESS_CHANGE_INPUT_PROVINCE' | translate }}</section>
                        <section class="col-sm-6">
                            <select
                                class="form-control"
                                id="province" name="province"
                                [(ngModel)]="request.province"
                                [ngClass]="{ 'is-invalid': formSubmitted && customForm.controls.province.errors }"
                                (click)="handleProvinceSelected()" 
                                required
                            >
                                <option
                                    *ngFor="let province of provinces"
                                    [value]="province.provinceCode"
                                >
                                    {{ province.provinceCode }}
                                </option>
                            </select>
                        </section>
                        <section class="col-sm-6 lb"><label class="star">*</label>{{ 'REQUEST_ADDRESS_CHANGE_INPUT_POSTAL_CODE' | translate }}</section>
                        <section class="col-sm-6">
                            <input type="text" 
                                class="form-control" 
                                id="postalCode" name="postalCode" 
                                [(ngModel)]="request.postalCode"   
                                [ngClass]="{ 'is-invalid': formSubmitted && customForm.controls.postalCode.errors }"
                                placeholder="{{ 'COMMON_LBL_REQUIRED' | translate }}"                                              
                                (input)="postalCodeValidator($event)" 
                                [pattern]="postalCodePattern" required maxlength="6"/>
                        </section>
                        <section class="col-sm-6 lb"><label class="star">*</label>{{ 'REQUEST_ADDRESS_CHANGE_INPUT_EFFECTIVE_CODE' | translate }}</section>
                        <section class="col-sm-6">
                            <div class="input-group">
                                <input 
                                    class="form-control" 
                                    placeholder="{{ 'COMMON_LBL_PLACEHOLDER_DATE' | translate }}" 
                                    id="effectiveDate" name="effectiveDate" 
                                    [(ngModel)]="requestEffectiveDate" 
                                    ngbDatepicker 
                                    #e="ngbDatepicker"
                                    [minDate]="{ year: thisYear, month: 1,  day: 1  }"
                                    [maxDate]="{ year: nextYear, month: 12, day: 31 }"
                                    (click)="e.toggle()"
                                    (ngModelChange)="effectiveDateValidator($event)" 
                                    [ngClass]="{ 'is-invalid': formSubmitted && (customForm.controls.effectiveDate.errors || invalidEffectiveDate) }"
                                    required maxlength="10">
                                <div class="input-group-append">
                                  <button type="button" class="btn" (click)="e.toggle()">
                                    <i class="fa fa-calendar"></i>
                                  </button>
                                </div>
                            </div>
                            <div *ngIf="formSubmitted && (customForm.controls.effectiveDate.errors || invalidEffectiveDateFormat)" class="is-invalid-format">
                                <small> {{ 'COMMON_LBL_INVALID_FORMAT' | translate }} </small>
                            </div>
                            <div *ngIf="formSubmitted && (customForm.controls.effectiveDate.errors || invalidEffectiveDate)" class="is-invalid-format">
                                <small> {{ 'REQUEST_ADDRESS_CHANGE_ERR_EFFECTIVE_DATE' | translate }} </small>
                            </div>
                        </section>
                    </div>
                    <div *ngIf="request.province !== addressChangeViewModel.province">
                        <p class="subtitle">{{ 'REQUEST_ADDRESS_CHANGE_TITLE_OUT_OF_PROVINCE' | translate }}</p>
                        
                        <div *ngIf="request.province != 'MB' && request.province != 'SK' && request.province != 'BC'" style="margin-bottom: 15px;">
                            <p>{{ 'REQUEST_ADDRESS_CHANGE_SUBTITLE1_OUT_OF_PROVINCE' | translate }}</p>
                            <section class="col-sm-6 lb"><label class="star">*</label>{{ 'REQUEST_ADDRESS_CHANGE_INPUT_INSURANCE_POLICY' | translate }}</section>
                            <section class="col-sm-6" style="text-align: right;">
                                <input type="file"
                                    id="insurancePolicyFileInput" name="insurancePolicyFileInput" 
                                    style="display: none"
                                    accept="application/pdf,image/bmp,image/jpg,image/jpeg,image/png,image/gif" 
                                    (change)="handleInsurancePolicyFileInput($event.target.files)"/>
                                <button type="button" id="insurancePolicyFileBtn" class="btn btn-secondary btn-expand">{{ 'COMMON_BTN_SELECT_FILE' | translate }}</button>
                                <div *ngIf="!insurancePolicyFile" [ngClass]="{ 'is-invalid-file': formSubmitted }"><small> {{ 'COMMON_LBL_NO_FILE' | translate }} </small></div>
                                <div *ngIf="insurancePolicyFile"><small>{{ insurancePolicyFile?.name }}</small></div>
                                <div *ngIf="insurancePolicyFile && invalidInsurancePolicyFile" [ngClass]="{ 'is-invalid-file': invalidInsurancePolicyFile }"><small> {{ 'COMMON_LBL_ERROR_FILE' | translate }} </small></div>
                            </section>
                        </div>

                        <div *ngIf="request.province === 'MB' || request.province === 'SK' || request.province === 'BC'" style="margin-bottom: 15px;">
                            <p>{{ 'REQUEST_ADDRESS_CHANGE_SUBTITLE1_OUT_OF_PROVINCE_BC' | translate }}</p>
                        </div>

                        <!-- <p>{{ 'REQUEST_ADDRESS_CHANGE_SUBTITLE2_OUT_OF_PROVINCE' | translate }}</p>
                        <section class="col-sm-6 lb"><label class="star">*</label>{{ 'REQUEST_ADDRESS_CHANGE_INPUT_OWNERSHIP' | translate }}</section>
                        <section class="col-sm-6" style="text-align: right;">
                            <input type="file"
                                id="ownershipFileInput" name="ownershipFileInput" 
                                style="display: none"
                                accept="application/pdf,image/bmp,image/jpg,image/jpeg,image/png,image/gif" 
                                (change)="handleOwnershipFileInput($event.target.files)"/>
                            <button type="button" id="ownershipFileBtn" class="btn btn-secondary btn-expand">{{ 'COMMON_BTN_SELECT_FILE' | translate }}</button>
                            <div *ngIf="!ownershipFile" [ngClass]="{ 'is-invalid-file': formSubmitted }"><small> {{ 'COMMON_LBL_NO_FILE' | translate }} </small></div>
                            <div *ngIf="ownershipFile"><small>{{ ownershipFile?.name }}</small></div>
                            <div *ngIf="ownershipFile && invalidOwnershipFile" [ngClass]="{ 'is-invalid-file': invalidOwnershipFile }"><small> {{ 'COMMON_LBL_ERROR_FILE' | translate }} </small></div>
                        </section> -->
                    </div>
                    <div *ngIf="formSubmitted && (customForm.invalid || invalidEffectiveDateFormat || invalidEffectiveDate || invalidInsurancePolicyFile || invalidOwnershipFile)" class="row" style="margin: auto;">
                        <div class="col-sm-12 error-note">
                            <label translate="COMMON_LBL_FORM_ERR_NOTE"></label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6"></div>
                        <div class="col-md-6">
                            <button type="submit" class="btn btn-secondary action-row">{{ 'COMMON_BTN_SUBMIT' | translate }}</button>
                        </div>
                    </div>
                </form>
            </div>
        </section>
        <section class="col-sm-2"></section>
    </div>
</div>    